(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-board-grid]');
    const cards = [...grid.querySelectorAll('[data-board-card]')];
    const filters = [...root.querySelectorAll('[data-board-filter]')];
    filters.forEach(input => {
      const available = new Set(cards.map(card => card.dataset[input.dataset.boardFilter]));
      if (input.dataset.boardFilter === 'size') {
        [...available].sort((a,b) => a.localeCompare(b,undefined,{numeric:true})).forEach(size => input.add(new Option(size,size)));
      }
      [...input.options].forEach(option => {
        const anyGroove = option.value === 'With Juice Groove' && [...available].some(value => value !== 'No Groove');
        if (option.value && !available.has(option.value) && !anyGroove) option.remove();
      });
    });
    const sort = root.querySelector('[data-board-sort]');
    const more = root.querySelector('[data-board-more]');
    const count = root.querySelector('[data-board-count]');
    let limit = 24;
    const restore = () => {
      const params = new URL(location.href).searchParams;
      filters.forEach(input => { const value = params.get(`board_${input.dataset.boardFilter}`) || ''; input.value = [...input.options].some(o => o.value === value) ? value : ''; });
      const value = params.get('board_sort') || 'featured';
      sort.value = [...sort.options].some(o => o.value === value) ? value : 'featured';
    };
    const render = (updateURL = false) => {
      const matched = cards.filter(card => filters.every(input => !input.value || (input.dataset.boardFilter === 'groove' && input.value === 'With Juice Groove' ? card.dataset.groove !== 'No Groove' : card.dataset[input.dataset.boardFilter] === input.value)));
      if (sort.value === 'price-ascending') matched.sort((a,b) => Number(a.dataset.price)-Number(b.dataset.price));
      if (sort.value === 'price-descending') matched.sort((a,b) => Number(b.dataset.price)-Number(a.dataset.price));
      if (sort.value === 'title-ascending') matched.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
      cards.forEach(card => { card.hidden = true; });
      matched.forEach((card, i) => { card.hidden = i >= limit; grid.append(card); });
      count.textContent = `Showing ${Math.min(limit,matched.length)} of ${matched.length} boards`;
      more.hidden = matched.length <= limit;
      root.querySelector('[data-board-clear]').hidden = !filters.some(input => input.value) && sort.value === 'featured';
      root.querySelector('[data-board-empty]').hidden = matched.length > 0;
      if (updateURL) {
        const url = new URL(location.href);
        filters.forEach(input => { const key = `board_${input.dataset.boardFilter}`; input.value ? url.searchParams.set(key,input.value) : url.searchParams.delete(key); });
        sort.value !== 'featured' ? url.searchParams.set('board_sort',sort.value) : url.searchParams.delete('board_sort');
        history.replaceState(null,'',url);
      }
    };
    filters.forEach(input => input.addEventListener('change',() => {limit=24;render(true);}));
    sort.addEventListener('change',() => {limit=24;render(true);});
    root.querySelector('[data-board-clear]').addEventListener('click',() => {filters.forEach(input => input.value='');sort.value='featured';limit=24;render(true);});
    more.addEventListener('click',() => {limit+=24;render();});
    window.addEventListener('popstate',() => {restore();limit=24;render();});
    root.querySelector('[data-board-controls]').hidden=false;
    restore();render();
  };
  const run=()=>document.querySelectorAll('[data-board-catalog]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
